import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-management',
  templateUrl: './project-management.component.html',
  styleUrls: ['./project-management.component.scss']
})
export class ProjectManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  /*end code*/

  ngAfterViewInit() {
    document.getElementById('preloader').classList.add('hide');
  }
}
